import React from 'react';
import SiteLinks from './SiteLinks.js';

// layout: same values as NavBar ("form" or "wide")
export default function Footer({ layout = "wide" }) {
    return (
        <div className="Footer">
            <div className={`Footer--inner NavBar--inner-${layout}`}>
                <a className="Footer--logo" href="https://kizabo.com/">
                    <img src="/images/kizabo-logo.png" alt="Kizabo home" className="Footer--logo-image" />
                </a>
                <div className="Footer--contact-details">
                    <a className="Footer--contact-text" href="mailto:support@kizabo.com">Contact us via support@kizabo.com</a>
                </div>
                <SiteLinks className="Footer--links" />
            </div>
        </div>
    );
}
